import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { useAspectRatio } from '@/hooks/useAspectRatio';
import { useNotice } from '@/hooks/useNotice';
import { theme } from '@/theme';
import CloseIcon from '@mui/icons-material/Close';
import {
    Box,
    Dialog,
    DialogContent,
    DialogContentText,
    IconButton,
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { NoticeContent, NoticeTitle } from './NoticeObject';
import './NoticePopup.scss';

const standardWidth: number = 1280;

type Props = {
    open: boolean;
    changeOpen: (b: boolean) => void;
    notice: NoticeProps;
};

export type NoticeProps = {
    id: string;
    lastDay: number;
    haveTitle?: boolean;
    imageLang: Array<string>;
};
export const NoticePopup = () => {
    const [openNotice, setOpenNotice] = useState<boolean>(false);
    const { playButtonAudio } = useContext(AudioPlayContext);
    const { haveNotice, currentNotice, closeNotice } = useNotice();

    useEffect(() => {
        setOpenNotice(haveNotice);
    }, [haveNotice]);
    const changeOpen = (b: boolean) => {
        setOpenNotice(b);
        playButtonAudio();
        if (!b) {
            closeNotice();
        }
    };
    return openNotice ? (
        <NoticePopupBase
            open={openNotice}
            changeOpen={changeOpen}
            notice={currentNotice}
        />
    ) : (
        <></>
    );
};
export const NoticePopupBase = (props: Props) => {
    const { innerWidth } = useAspectRatio();

    const { open, changeOpen, notice } = props;

    //scaling for fulfill 4K resolution
    const [scaling, setScaling] = useState<number>(1);
    // const { isLandscape } = useContext(ScreenContext);

    const handleClose = () => {
        changeOpen(false);
    };
    useEffect(() => {
        if (innerWidth > standardWidth) setScaling(innerWidth / standardWidth);
        else setScaling(1);
    }, [innerWidth]);
    return (
        <Dialog
            open={open}
            // onClose={handleClose}
            // hideBackdrop={true}
            disableEscapeKeyDown={false}
            PaperProps={{
                sx: {
                    margin: 0,
                    borderRadius: `${0.167 * scaling}rem`,
                    backgroundColor: '#24211D',
                    border: '2px solid #ffffff33',
                    boxShadow: '0px 0px 30px 0px rgba(0, 0, 0, 0.35)',
                    zIndex: theme.zIndex.drawer + 100,
                    minWidth: `${20.4 * scaling}rem`,
                    maxWidth: '80%',
                    minHeight: '20%',
                    maxHeight: '80%',
                },
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '0px',
                    right: '0px',
                }}
            >
                <IconButton
                    sx={{
                        height: `${2.333 * scaling}rem`,
                        width: `${2.333 * scaling}rem`,
                        cursor: 'pointer',
                    }}
                    onClick={handleClose}
                >
                    <CloseIcon
                        sx={{
                            width: `${20 * scaling}px`,
                            height: `${20 * scaling}px`,
                        }}
                    />
                </IconButton>
            </Box>
            <DialogContentText
                sx={{
                    marginTop: `${1.2 * scaling}rem`,
                    fontSize: `${0.9 * scaling}rem`,
                    textAlign: 'center',
                    color: theme => theme.palette.text.primary,
                }}
            >
                <NoticeTitle {...notice} scaling={scaling} />
            </DialogContentText>
            <DialogContent
                sx={{
                    padding: `${20 * scaling}px ${24 * scaling}px`,
                    justifyContent: 'center',
                    display: 'flex',
                }}
            >
                <NoticeContent {...notice} scaling={scaling} />
            </DialogContent>
        </Dialog>
    );
};
